export const DEFAULT_WORKER = '0'